var map = {
	"./box-usz.svg": "b51a",
	"./box-zsd.svg": "ac5c",
	"./box1.svg": "c8bd",
	"./fsin.svg": "b684",
	"./sp1.svg": "5dd4",
	"./sp2.svg": "6725",
	"./sp3.svg": "9e74",
	"./sp4.svg": "3cc7",
	"./sp5.svg": "40ae",
	"./usz.svg": "9830",
	"./za.svg": "3d44",
	"./zsd.svg": "e11d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b79";